import * as z from "zod";

export const acceptUpsAgreement = {
  name: "acceptUpsAgreement" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
